
function ns(str) {
  return 'CHATTER_SETTINGS_' + str
}

export const SET_AUTH_LIST            = ns('SET_AUTH_LIST');
export const AUTH_ADD_OR_UPDATED      = ns('AUTH_ADD_OR_UPDATED');
export const AUTH_LIST_UPDATE         = ns('AUTH_LIST_UPDATE');
export const SET_SETTINGS_NOT_LOADED  = ns('SET_SETTINGS_NOT_LOADED');

export const DISMISS_ALERTS           = ns('DISMISS_JUST_ADDED');

export const UPDATE_PROVIDER_FILTERS  = ns('UPDATE_PROVIDER_FILTERS');
export const UPDATE_FILTERS           = ns('UPDATE_FILTERS');

export const DELETE_LISTING_GROUP     = ns('LISTING_GROUP_DELETE');

export const ADD_PAGE_MENTION         = ns('ADD_PAGE_MENTION');
export const REMOVE_PAGE_MENTION      = ns('REMOVE_PAGE_MENTION');


